import checkout from "./form";

const {
  formField: { organizeName, taxId },
} = checkout;

const initialValues = {
  [organizeName.name]: "",
  [taxId.name]: "",
};

export default initialValues;
